<div>
    <section class="seccionBuscar">
        <div class="cw">

            <br>
            <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="2rem">

                <!-- menu mobile -->
                <div class="containerBuscarMobile" fxLayoutAlign="center center" fxFlex="100%" fxShow="false"
                    fxShow.lt-md="true">
                    <input type="text" [(ngModel)]="textoBusqueda" (ngModelChange)="filtrar()" ng-keyup="filtrar()"
                        class="fw" placeholder="Buscar por texto">
                </div>

                <div class="containerTipoBusqueda" fxLayoutAlign="center center" fxFlex="100%" fxShow="false"
                    fxShow.lt-md="true">
                    <div class="tipoBusquedaButton w-100" (click)="tipoBusqueda='cursos'; filtrar();"
                        [ngClass]=" {'backGray2':tipoBusqueda === 'cursos'}">
                        <p class="centertext">Cursos</p>
                    </div>
                    <div class="tipoBusquedaButton w-100 border-l" (click)="tipoBusqueda='instructores'; filtrar();"
                        [ngClass]=" {'backGray2':tipoBusqueda === 'instructores'}">
                        <p class="centertext">Instructores</p>
                    </div>
                    <div class="tipoBusquedaButton w-100 border-l" (click)="tipoBusqueda='empresas'; filtrar();"
                        [ngClass]=" {'backGray2':tipoBusqueda === 'empresas'}">
                        <p class="centertext">Empresas</p>
                    </div>
                </div>

                <div fxLayout="column" fxFlex="16%" fxShow="true" fxShow.lt-md="false">
                    <div>
                        <h6 class="ft500 ft14  pdb10">Categoría</h6>
                    </div>
                    <!-- <div class="containerCheckbox" *ngFor="let item of categorias, let i = index">
                        <input type="checkbox" class="checkboxFilter" value="{{item}}"
                            [checked]="seleccionCategorias.indexOf(item) > -1" (click)="cambioSeleccion(item)"><span
                            class="textCheckboxFilter">{{item}}</span>
                    </div> -->

                    <div class="checkboxContainer" *ngFor="let item of categoriasContadas, let i = index">
                        <mat-checkbox *ngIf="item.cant != 0" [value]="item.categoria"
                            [checked]="seleccionCategorias.indexOf(item.categoria) > -1"
                            (change)="cambioSeleccion(item.categoria)"> <span class="ft14">{{item.categoria}}
                                ({{item.cant}})</span> </mat-checkbox>
                        <mat-checkbox *ngIf="item.cant == 0" [value]="item.categoria"
                            [checked]="seleccionCategorias.indexOf(item.categoria) > -1"
                            (change)="cambioSeleccion(item.categoria)" [disabled]="true"> <span class="ft14 gray-4">{{item.categoria}}
                                ({{item.cant}})</span> </mat-checkbox>
                    </div>

                    <div class="mgt20 mgb10">
                        <h6 class="ft500 ft14">Ordenar por:</h6>
                    </div>
                    <mat-radio-group [(ngModel)]="seleccionOrden" (change)="filtrar()">
                        <mat-radio-button *ngFor="let item of ordenar[tipoBusqueda]" [value]="item">
                            <span class="ft14">{{item}}</span>
                        </mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="tipoBusqueda=='cursos'" class="mgt20 mgb10">
                        <h6 class="ft500 ft14">Nivel: </h6>
                    </div>
                    <mat-radio-group *ngIf="tipoBusqueda=='cursos'" [(ngModel)]="filtroNivel" (change)="filtrar()">
                        <mat-radio-button value="">
                            <span class="ft14">Todos</span>
                        </mat-radio-button>
                        <mat-radio-button *ngFor="let item of niveles" [value]="item">
                            <span class="ft14">{{item}}</span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>

                <div fxLayout="column" fxFlex="70%" fxFlex.lt-lg="80%" fxFlex.lt-md="100%">

                    <!-- FILTROS DE BUSQUEDA -->

                    <div fxLayout="row" fxLayoutGap="1.5rem" fxFlex="100%" fxShow="true" fxShow.lt-md="false">
                        <div fxLayout="column">
                            <h6 class="ft500 ft14  pdb10"> Tipo de busqueda</h6>
                            <div fxLayout="row" class="border radius3">
                                <div class="tipoBusquedaButton" (click)="tipoBusqueda='cursos'; filtrar();"
                                    [ngClass]=" {'backGray2':tipoBusqueda === 'cursos'}">
                                    <span>Cursos</span>
                                </div>
                                <div class="tipoBusquedaButton border-l"
                                    (click)="tipoBusqueda='instructores'; filtrar();"
                                    [ngClass]=" {'backGray2':tipoBusqueda === 'instructores'}">
                                    <span>Instructores</span>
                                </div>
                                <div class="tipoBusquedaButton border-l" (click)="tipoBusqueda='empresas'; filtrar();"
                                    [ngClass]=" {'backGray2':tipoBusqueda === 'empresas'}">
                                    <span>Empresas</span>
                                </div>
                            </div>
                        </div>

                        <div fxLayout="column" fxFlex="100%">
                            <h6 class="ft500 ft14  pdb10"> Buscar por texto</h6>
                            <div fxLayout="row" class="fw">
                                <input type="text" [(ngModel)]="textoBusqueda" (ngModelChange)="filtrar()"
                                    ng-keyup="filtrar()" class="fw shadow8 gray-9">
                                <!-- <button type="button" class="darkButton mgl10" (click)="filtrar()">
                                    buscar</button> -->
                            </div>
                        </div>

                        <!-- <div>
                            <h6 class="ft500 ft14 pdb10">Ordenar resultados</h6>
                            <select [(ngModel)]="seleccionOrden" (change)="filtrar()" name="orden" class="fw">
                                <option value="null" selected>Seleccione</option>
                                <option *ngFor="let item of ordenar[tipoBusqueda]" [ngValue]="item">{{item}}</option>
                            </select>
                        </div> -->
                    </div>

                    <!-- Container resultados buscador -->
                    <div *ngIf="loaded == 1" class="pdt10">

                        <!-- Lista de Cursos -->
                        <div *ngIf="tipoBusqueda === 'cursos'">
                            <div fxLayout="row" fxLayoutAlign="space-between start" *ngFor="let curso of filteredCursos"
                                class="shadow8 pdr10 border mgt10 mgb20 radius3 w-100">
                                <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutGap.lt-md=".5rem" fxFlex="100%"
                                    routerLink="/curso/{{curso.id}}" class="cursorPointer">
                                    <span fxShow="true" fxShow.lt-md="false">
                                        <img [src]=curso.foto class="fotoDestacada">
                                    </span>
                                    <div fxShow="false" fxShow.lt-md="true">
                                        <img [src]=curso.foto class="fotoDestacada2">
                                    </div>
                                    <div class="fw" fxLayout="column">
                                        <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100%">
                                            <div class="pdt10 pdb05" fxLayout="column" fxLayoutAlign="space-between"
                                                fxFlex="100%" fxFlex.lt-md="100%">
                                                <div>
                                                    <p ngClass.gt-sm="default-font-color ft14 ft500 mgb03"
                                                        ngClass.lt-md="default-font-color ft12 ft500 mgb0">
                                                        {{curso.titulo}}
                                                    </p>
                                                    <p ngClass.gt-sm="ft12 mgt0" ngClass.lt-md="ft11" fxShow="true"
                                                        fxShow.lt-md="false"> {{curso.resumen}}</p>
                                                    <span class="ft500 ft10 dark-font-color nowrap" fxShow="false"
                                                        fxShow.lt-md="true">
                                                        {{curso.precioFinal}}$ USD </span>
                                                </div>
                                            </div>
                                            <div class="mgt10 mgr10" fxFlex=10% fxLayoutAlign="end " fxShow="true"
                                                fxShow.lt-md="false">
                                                <span class="ft500 ft12 dark-font-color nowrap"> {{curso.precioFinal}}$
                                                    USD </span>
                                            </div>
                                        </div>

                                        <div class="mgb10" fxLayout="row wrap" fxLayoutAlign=" center">
                                            <img [src]=curso.instructorFoto class="avatar2" fxShow="true"
                                                fxShow.lt-md="false">

                                            <span routerLink="/instructor/{{curso.instructorId}}"
                                                ngClass.gt-sm="mgl10 chip backGray2 gray-8 cursorPointer ft10"
                                                ngClass.lt-md="chip backGray2 gray-8 cursorPointer ft10">{{curso.instructorNombre}}</span>

                                            <span *ngIf="curso.empresaNombre" routerLink="/empresa/{{curso.empresaId}}"
                                                fxShow="true" fxShow.lt-md="false"
                                                class="mgl10 chip backGray2 gray-8 cursorPointer ft10">{{curso.empresaNombre}}</span>


                                            <mat-icon class="mgl10 linkIcon gray-6 mgr05 ft18" fxShow="true"
                                                fxShow.lt-md="false">access_time</mat-icon>
                                            <span class="gray-8 ft11 nowrap" fxShow="true"
                                                fxShow.lt-md="false">{{curso.duracion/60 | number:'1.0-1'}} h
                                            </span>
                                            <div fxShow="true" fxShow.lt-md="false">
                                                <ngb-rating class="mgl20 mgb03" [(rate)]="curso.valoracion" [max]="5"
                                                    [readonly]="true" f>
                                                    <ng-template let-fill="fill">
                                                        <span [class.filled]="fill != 0" [class.notfilled]="fill == 0"
                                                            class="mgr03 ft15">
                                                            &#9733;
                                                        </span>
                                                    </ng-template>
                                                </ngb-rating>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>

                        <!-- Lista de Insructores -->
                        <div *ngIf="tipoBusqueda === 'instructores'">
                            <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutAlign="space-between"
                                *ngFor="let instructor of filteredInstructores"
                                class="pdr10 border shadow8 mgt10 mgb20 radius3 w-100">
                                <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutGap.lt-md=".5rem" fxFlex="100%"
                                    routerLink="/instructor/{{instructor.id}}" class="cursorPointer">
                                    <span fxShow="true" fxShow.lt-md="false">
                                        <img [src]=instructor.foto class="fotoDestacada">
                                    </span>
                                    <div fxShow="false" fxShow.lt-md="true">
                                        <img [src]=instructor.foto class="fotoDestacada2">
                                    </div>
                                    <div class="pdt10 pdb05" fxLayout="column" fxLayoutAlign="space-between">
                                        <div>
                                            <p ngClass.gt-sm="default-font-color ft14 ft500 mgb03"
                                                ngClass.lt-md="mgb03 default-font-color ft12 ft500 ">
                                                {{instructor.nombre}} </p>
                                            <p ngClass.gt-sm="mgt0 ft12" ngClass.lt-md="mgt0 ft10">
                                                {{instructor.resumen}}
                                            </p>
                                        </div>

                                        <div class="mgb05" fxLayout="row wrap " fxLayoutAlign=" center">

                                            <span class="chip backGray2 gray-8 cursorPointer ft10">
                                                {{instructor.cantCursos}}
                                                <span *ngIf="instructor.cantCursos===1" class="mgl03 gray-8 ft10">
                                                    curso</span>
                                                <span *ngIf="instructor.cantCursos>1" class="mgl03 gray-8 ft10">
                                                    cursos</span>
                                            </span>

                                            <span *ngIf="instructor.empresaNombre"
                                                routerLink="/empresa/{{instructor.empresaId}}"
                                                class="mgl10 chip backGray2 gray-8 cursorPointer ft10" fxShow="true"
                                                fxShow.lt-md="false">
                                                {{instructor.empresaNombre}}
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Lista de Empresas -->
                        <div *ngIf="tipoBusqueda === 'empresas'">
                            <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutAlign="space-between"
                                *ngFor="let empresa of filteredEmpresas"
                                class="pdr10 border mgt10 mgb20 shadow8 radius3">
                                <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutGap.lt-md=".5rem" fxFlex="100%"
                                    routerLink="/empresa/{{empresa.id}}" class="cursorPointer">
                                    <span fxShow="true" fxShow.lt-md="false">
                                        <img [src]=empresa.foto class="fotoDestacada">
                                    </span>
                                    <div fxShow="false" fxShow.lt-md="true">
                                        <img [src]=empresa.foto class="fotoDestacada2">
                                    </div>
                                    <div class="pdt10 pdb05" fxLayout="column" fxLayoutAlign="space-between">
                                        <div>
                                            <p ngClass.gt-sm="default-font-color ft14 ft500 mgb03"
                                                ngClass.lt-md="mgb03 default-font-color ft12 ft500 ">{{empresa.nombre}}
                                            </p>
                                            <p ngClass.gt-sm="mgt0 ft12" ngClass.lt-md="ft10">{{empresa.resumen}}</p>
                                        </div>

                                        <div class="mgb05" fxLayout="row wrap" fxLayoutAlign=" center">
                                            <span class="chip backGray2 gray-8 cursorPointer ft10">
                                                {{empresa.cantCursos}}
                                                <span *ngIf="empresa.cantCursos===1" class="mgl03 gray-8 ft10">
                                                    curso</span>
                                                <span *ngIf="empresa.cantCursos>1" class="mgl03 gray-8 ft10">
                                                    cursos</span>
                                            </span>

                                            <span fxShow="true" fxShow.lt-md="false"
                                                class="mgl10 chip backGray2 gray-8 cursorPointer ft10">
                                                {{empresa.cantInstructores}}
                                                <span *ngIf="empresa.cantInstructores===1" class="mgl03 gray-8 ft10">
                                                    instructor</span>
                                                <span *ngIf="empresa.cantInstructores>1" class="mgl03 gray-8 ft10">
                                                    instructores</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="loaded == 0">
                        <div *ssrExclude>
                            <spinner></spinner>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>